<router-outlet />
<ngx-sonner-toaster />

@if (_loaderService.getLoading()()) {
    <app-loader [textInfo]="_loaderService.getTextInfo()"></app-loader>
}

@for (routeKey of desktopMessageRouteKeys(); track routeKey) {
    <app-desktop-message></app-desktop-message>
}


@if (_helpService.getStateButtonHelp()() && _router.url !== '/') {
    <app-button-help></app-button-help>
}